import React, { useMemo } from "react";
import { FaApple, FaGoogle } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import "./MobileAppPromoFloat.css";

export default function MobileAppPromoFloat() {
  const { t } = useTranslation();
  const iosUrl = useMemo(
    () => process.env.REACT_APP_IOS_APP_STORE_URL || "https://apps.apple.com/",
    []
  );
  const androidUrl = useMemo(
    () => process.env.REACT_APP_ANDROID_GOOGLE_PLAY_URL || "https://play.google.com/store",
    []
  );

  const cheerSrc = `${process.env.PUBLIC_URL || ""}/images/image/cheer.png`;

  return (
    <div className="as-mobile-promo-float" role="complementary" aria-label="Mobile app promotion">
      <div
        className="as-mobile-promo-float__panel"
        style={{ backgroundImage: `url(${cheerSrc})` }}
        aria-label="Download buttons"
      >
        <div className="as-mobile-promo-float__label">
          {t("general.mobile_apps_available") || "Mobile Apps Available"}
        </div>
        <div className="as-mobile-promo-float__board">
          <div className="as-mobile-promo-float__buttons">
            <a
              className="as-store-btn as-store-btn--ios"
              href={iosUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download on the App Store"
            >
              <FaApple className="as-store-btn__icon" aria-hidden="true" />
            </a>

            <a
              className="as-store-btn as-store-btn--android"
              href={androidUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Get it on Google Play"
            >
              <FaGoogle className="as-store-btn__icon" aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

